module.exports = __webpack_public_path__ + "img/wechatpay.30adb4cc.png";